module.exports = __webpack_public_path__ + "media/images/flags/32/Ghana-5a01b308734badd40b4122628233ccab.png";